<template>
  <v-breadcrumbs :items="items">
    <template v-slot:item="{ item }">
      <v-breadcrumbs-item
          :to="item.href"
          :disabled="item.disabled"
      >
        {{ item.text.toUpperCase() }}
      </v-breadcrumbs-item>
    </template>
    <div class="card_container" >
      <div class="card_header" >
        <div>เพิ่มข้อมูลชิ้นงาน</div>
      </div>

      <v-breadcrumbs :items="items">
        <template v-slot:item="{ item }">
          <v-breadcrumbs-item
              :to="item.href"
              :disabled="item.disabled"
          >
            {{ item.text.toUpperCase() }}
          </v-breadcrumbs-item>
        </template>
      </v-breadcrumbs>
      <div class="form_card" >
        <v-form
            ref="form"
            v-model="valid"
            lazy-validation
        >
          <v-text-field
              v-model="names"
              :rules="[v => !!v || 'กรุณากรอกชื่อชิ้นงาน']"
              label="ชื่อชิ้นงาน"
              required
          ></v-text-field>

          <v-text-field
              v-model="code"
              :rules="[v => !!v || 'กรุณากรอกรหัสชิ้นงาน']"
              label="รหัสชิ้นงาน"
              required
          ></v-text-field>

          <v-textarea
              v-model="description"
              :rules="[v => !!v || 'กรุณากรอกคำอธิบาย']"
              label="คำอธิบาย"
              required
          ></v-textarea>


          <v-select
              v-model="category_id"
              :items="category_item"
              v-on:change="GetSubategory()"
              item-text="label"
              item-value="id"
              :rules="[v => !!v || 'กรุณาเลือกประเภทชิ้นงาน']"
              label="ประเภทชิ้นงาน"
              required
          ></v-select>

          <v-select
              v-model="subcategory_id"
              :items="subcategory_item"
              item-text="label"
              item-value="id"
              :rules="[v => !!v || 'กรุณาเลือกประเภทชิ้นงานย่อย']"
              label="ประเภทชิ้นงานย่อย"
              required
          ></v-select>

          <v-text-field
              v-model="amount"
              :rules="[
                  v => !!v || 'กรุณากรอกจำนวนสินค้า',
                  v => v > 0 || 'จำนวนต้องมากกว่า 0 และเป็นตัวเลขเท่านั้น',
                  ]"
              label="จำนวนสินค้า"
              required
          ></v-text-field>


          <v-text-field
              v-model="min"
              :rules="[v => !!v || 'กรุณากรอกปริมาณสินค้าขั้นต่ำ']"
              label="ปริมาณสินค้าขั้นต่ำ"
              required

          ></v-text-field>

          <v-text-field
              v-model="max"
              :rules="[v => !!v || 'กรุณากรอกปริมาณสินค้าคงคลัง']"
              label="ปริมาณสินค้าคงคลัง"
              required

          ></v-text-field>


          <v-text-field
              v-model="unit"
              :rules="[v => !!v || 'กรุณากรอกหน่วยนับ']"
              label="หน่วยนับ"
              required

          ></v-text-field>

          <v-text-field
              v-model="price"
              label="ราคาสินค้า"
          ></v-text-field>

          <v-text-field
              v-model="limit"
              label="จำนวนเบิกสินค้า/วัน"
          ></v-text-field>


          <v-text-field
              v-model="position"
              :rules="[
                  v => !!v || 'กรณากรอกตำแหน่งชิ้นงาน',
                  v => /^[0-9]+$/.test(v) || 'ตำแหน่งต้องเป็นตัวเลขเท่านั้น',
                  ]

"
              label="ตำแหน่งชิ้นงาน"
              required
          ></v-text-field>

          <v-file-input
              @change="Preview_image"
              :rules="[v => !!v || 'กรุณาอัพโหลดรูป']"
              accept="image/png, image/jpeg, image/bmp"
              placeholder="เลือก รูปโปรไฟล์"
              prepend-icon="mdi-camera"
              label="รูปโปรไฟล์"
          ></v-file-input>
          <div class="image_preview_container" >
            <img  id="image_preview" src=""  />
          </div>


          <div align="center" style="margin-top: 2rem" >
            <v-btn
                color="success"
                class="mr-4"
                @click="validate"
            >
              เพิ่มข้อมูล
            </v-btn>

            <v-btn
                color="error"
                class="mr-4"
                @click="reset"
            >
             ล้างค่า
            </v-btn>


          </div>

        </v-form>
      </div>

    </div>
  </v-breadcrumbs>



</template>

<script>
import {AddProduct, GetCategory, GetMachine, GetSubCategory} from "../../lib/controller";
import {baseUrl, position_amount} from "../../const/api";
import $ from 'jquery'


export default {
  name: "Users",
  data: () => ({
    rules: [
      value => !value || value.size < 2000000 || 'Avatar size should be less than 2 MB!',
    ],
    machine_item:{},
    machine_id:0,
    names:"",
    code:"",
    amount:0,
    min:"",
    max:"",
    unit:"",
    description:"",
    position_amount:position_amount,
    valid: true,
    file:"",
    limit:"",
    machine: JSON.parse(localStorage.getItem('user')).machine_id,
    email: '',
    price: '',
    rfidcode: '',

    email_rules: [
      v => !!v || 'E-mail is required',
      v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
    ],


    subcategory_id: '',
    category_id: '',
    category_item:[],
    subcategory_item:[],


    name: '',
    nameRules: [
      v => !!v || 'Name is required',
      v => (v && v.length <= 10) || 'Name must be less than 10 characters',
    ],




    select: null,
    checkbox: false,

    baseUrl:baseUrl,
    items: [
      {
        text: 'Home',
        disabled: false,
        href: '/',
      },
      {
        text: 'ข้อมูลชิ้นงาน',
        disabled: false,
        href: '/Product',
      },
      {
        text: 'เพิ่มข้อมูลชิ้นงาน',
        disabled: true,
        href: '/Users',
      },
    ],
    dialog: false,
    dialogDelete: false,
    headers: [
      {
        text: 'รูปโปรไฟล์',
        align: 'start',
        sortable: false,
        value: 'image',
      },
      { text: 'ชื่อ', value: 'first_name' },
      { text: 'นามสกุล', value: 'last_name' },
      { text: 'แผนก', value: 'departments[0].title' },
      { text: 'RFID', value: 'rfidcode' },
      { text: 'Actions', value: 'actions', sortable: false },
    ],
    desserts: [],
    editedIndex: -1,
    resultData:[],
  }),

  computed: {

  },
  watch: {

  },

  created () {
    this.initialize()
    this.GetCategory()
    this.GetMachines()

    this.$mqtt.publish('param/param/param/test', 'message')
  },

  methods: {
    initialize () {

    },
    async GetMachines(){
      let machine = [];
      const { status , results } = await GetMachine();
      if(status === 200){

        results.data.forEach(function (result){
          console.log(result)
          machine.push({
            "label":result.title,
            "id":result.machine_number,
          })
        });
      }

      this.machine_item = machine;
      console.log(this.itemss)

    },
    validate () {
      console.log(this.file)
      if(this.$refs.form.validate()){
        this.ProductAdd();
      }
    },
    reset () {
      this.$refs.form.reset()
      $('#image_preview').attr('src', '');
    },
    async ProductAdd(){
      let Swal = this.$swal;

      let formData = new FormData();
      formData.append("name",this.names)
      formData.append("code",this.code)
      formData.append("amount",this.amount)
      formData.append("description",this.description)
      formData.append("subcategory_id",this.subcategory_id)
      formData.append("category_id",this.category_id)
      formData.append("position",this.position)
      formData.append("file",this.file)
      formData.append("machine_id",JSON.parse(localStorage.getItem('user')).machine_id)
      formData.append("min",this.min)
      formData.append("max",this.max)
      formData.append("unit",this.unit)
      formData.append("price",this.price)
      formData.append("limit",this.limit)

      const { status , results } = await AddProduct(formData,this.machine_id);

      console.log("==========results=========")
      console.log(results)

      if(status === 200){
        Swal({
          icon: 'success',
          title: 'Success',
        })


        this.$mqtt.publish("update",this.machine_id)


        this.$refs.form.reset()
        $('#image_preview').attr('src', '');
        console.log(results)
      }else{
        console.log(results)

        Swal({
          icon: results.icon,
          title: results.message,
        })



      }

    },

    async GetCategory(){
      let category = [];
      const { status , results } = await GetCategory();
      if(status === 200){

        results.data.forEach(function (result,index){
          console.log(index)
          category.push({
            "label":result.title,
            "id":result.category_id,
          })
        });
      }

      this.category_item = category;
      console.log(this.itemss)

    },

    async GetSubategory(){
      this.subcategory_id = '';
      let subcategory = [];
      const params = {
        machine:this.machine
      }
      const { status , results } = await GetSubCategory(this.category_id,params);
      if(status === 200){

        results.data.forEach(function (result,index){
          console.log(index)
          subcategory.push({
            "label":result.title,
            "id":result.sub_category_id,
          })
        });
      }

      this.subcategory_item = subcategory;


    },
    Preview_image(e) {
      if (e) {
        this.file = e;
        $('#image_preview').attr('src', URL.createObjectURL(e)); // jQuery selector
      }
    },
  },
}


</script>

<style scoped>
.card_container{
  width: 100%;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #ffffff;
  background-clip: border-box;
  border: 1px solid #EBEDF3;
  border-radius: 0.42rem;
}
.card_header{
  padding: 1.5rem 2rem;
  margin-bottom: 0;
  background-color: #ffffff;
  border-bottom: 1px solid #EBEDF3;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.form_card{
  padding:2rem;
}
.image_preview_container{
  display: flex;
  justify-content: center;
  align-items: center;
}
#image_preview{
  width: 20rem;
  text-align: center;
}
</style>
